
$( ( $ ) => {
  const fadeInEffect = ( entries, observer ) => {
    entries.forEach( ( entry ) => {
      if ( entry.isIntersecting ) {
        $( entry.target ).addClass( 'in-view' );
        observer.unobserve( entry.target );
      }
    } );
  };
  
  const sliders = $( '.bs-slider--solutions-see-everyone-slider > div .slick-slide-wrapper' );

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver( fadeInEffect, options );
  sliders.each( ( index, slider ) => observer.observe( slider ) );

  const handleResize = () => {
    if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
      sliders.each( ( index, slider ) => observer.observe( slider ) );
    } else {
      sliders.each( ( index, slider ) => observer.unobserve( slider ) );
    }
  };

  $( window ).resize( handleResize );
  handleResize();
} );
